import { render, staticRenderFns } from "./buildDiscount.vue?vue&type=template&id=e183a5c2&"
import script from "./buildDiscount.vue?vue&type=script&lang=js&"
export * from "./buildDiscount.vue?vue&type=script&lang=js&"
import style0 from "./buildDiscount.vue?vue&type=style&index=0&id=e183a5c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports